module.exports = "/static/assets/e43c93409f478be727f730410954c96d.png";